import { Segmented } from '../components/Segmented';
import { Icon } from '../icons';
import { useTheme, type ThemePref } from './ThemeProvider';

export function ThemeSwitch({ testPrefix = 'theme-option' }: { testPrefix?: string }) {
  const { pref, setPref } = useTheme();
  return (
    <Segmented<ThemePref>
      label="Appearance"
      value={pref}
      onChange={setPref}
      options={[
        { value: 'system', label: <span className="inline-flex items-center gap-1.5"><Icon name="desktop" size={16} />System</span>, testId: `${testPrefix}-system` },
        { value: 'light', label: <span className="inline-flex items-center gap-1.5"><Icon name="sun" size={16} />Light</span>, testId: `${testPrefix}-light` },
        { value: 'dark', label: <span className="inline-flex items-center gap-1.5"><Icon name="moon" size={16} />Dark</span>, testId: `${testPrefix}-dark` },
      ]}
    />
  );
}
